<template>
  <div
    :class="$style.root"
  >
    <LayoutPageHeaderComponent :data="localizedData" />

    <CoreBlocksComponent
      v-if="localizedData?.blocks"
      :blocks="localizedData.blocks"
    />

    <div
      :class=$style.map
      v-if="isAboutPage"
    >
      <LMap
        ref="mapElement"
        :zoom="16"
        :center="[42.068450,19.515550]"
        :use-global-leaflet="false"
      >
        <LTileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution="&amp;copy; <a href=&quot;https://www.openstreetmap.org/&quot;>OpenStreetMap</a> contributors"
          layer-type="base"
          name="OpenStreetMap"
        />
        <l-marker :lat-lng="[42.068450,19.515550]"></l-marker>
      </LMap>
    </div>
  </div>
</template>

<script setup>
const route = useRoute()

const props = defineProps({
  pageData: Object
})

const localizedData = computed(() => {
  return i18nGetLocalizedData(baseStrapiGetAttributes(props?.pageData?.data))
})

const isAboutPage = computed(() => {
  return route.params?.slug === 'about-us' || route?.params?.slug === 'rreth-nesh'
})

const mapElement = ref(null)
// const mapRef = useMapboxRef('mapElement');
</script>

<style module>
.root {
}

.map {
  composes: container--medium from global;
  aspect-ratio: 9 / 6;

  display: flex;

  position: relative;
  z-index: 0;
  margin-top: calc(var(--unit--vertical) * 2);
}

.marker {
  width: var(--unit--vertical);
  height: var(--unit--vertical);
  background-color: var(--color--background);
  clip-path: polygon(100% 0, 0 0, 50% 100%);
}
.root :global(.mapboxgl-ctrl) {
  display: none !important;
}

.mapInner {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 0;
}
</style>
